import { useQuery } from "@tanstack/react-query";
import { regionKeys, regionService } from "@/services/regionService";

/**
 * Active regions plus the region the carousel works on: the requested one when
 * it is active, otherwise the first active region (the list page default).
 * `error` is set when the regions could not be loaded, so callers can show it
 * (with `retry`) instead of a false "no regions".
 */
export function useCarouselRegion(requestedRegionId: string) {
  const {
    data: regions = [],
    isLoading,
    error,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: regionKeys.active(),
    queryFn: () => regionService.listActive(),
  });

  const regionId = regions.some((region) => region.id === requestedRegionId)
    ? requestedRegionId
    : (regions[0]?.id ?? "");

  return {
    regions,
    isLoading,
    error,
    retry: () => void refetch(),
    isRetrying: isRefetching,
    regionId,
  };
}
